import { render, staticRenderFns } from "./host-set-onlineRegistration.vue?vue&type=template&id=608798f0&scoped=true&"
import script from "./host-set-onlineRegistration.vue?vue&type=script&lang=js&"
export * from "./host-set-onlineRegistration.vue?vue&type=script&lang=js&"
import style0 from "./host-set-onlineRegistration.vue?vue&type=style&index=0&id=608798f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608798f0",
  null
  
)

export default component.exports